import React from "react";

function InfoIcon (props) {
    const { idAttribute, fill, classname, click } = props;

    return (
		<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={ fill } id={ idAttribute } className={ classname } onClick={ click !== undefined ? click : null }>
			<g id="Layer_2" data-name="Layer 2"><path d="m19.6 4.4a10.74 10.74 0 0 0 -17 12.76.3.3 0 0 1 0 .2l-.79 2.64a1.78 1.78 0 0 0 .44 1.74 1.75 1.75 0 0 0 1.75.44l2.65-.79a.26.26 0 0 1 .2 0 10.62 10.62 0 0 0 5.15 1.36 11.47 11.47 0 0 0 2.31-.24 10.75 10.75 0 0 0 5.29-18.11z" fill="#0db561"></path><g fill="#fff"><circle cx="12" cy="7.8" r="2"></circle><path d="m12 10.83a2 2 0 0 0 -2 2v3.56a2 2 0 0 0 4 0v-3.56a2 2 0 0 0 -2-2z"></path></g></g>
		</svg>
    );
}

export default InfoIcon;
